/* @flow */
import {get, set, map, reduce, isUndefined} from 'lodash';

export type Field =
    string
  | [string, Field[]]
;

const extract = (obj: Object, fields: Field[]): Object =>
  reduce(fields, (result: Object, field: Field): Object => {
    let val;
    if (Array.isArray(field)) {
      const [key, subfields] = field;
      const childArray = get(obj, key);
      val = map(childArray, (element: Object): Object =>
        extract(element, subfields)
      );
      return set(result, key, val);
    }
    val = get(obj, field);
    if (!isUndefined(val)) {
      set(result, field, val);
    }
    return result;
  }, {});

export default extract;
